/**
 * Why a browser is opted out, stored as the value of the opted-out marker. Every non-zero value
 * halts, so the worker and any older SDK, which test only whether the marker is set, stay halted
 * whatever the source.
 *
 * @internal
 */
export enum OptOutSource {
    /** `opt_out` or `optOut()`: lasts until `opt_in`. */
    EXPLICIT_REQUEST = 1,
    /** The site reported consent denied; consent granted again undoes it. */
    CONSENT_DENIED = 2,
}
